var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"color":"grey","text-transform":"uppercase","text-align":"left","border-bottom":"1px solid #ddd","height":"24px","width":"100%","font-weight":"300","letter-spacing":".05em"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }